enum LocaleNamespaceEnum {
  NOTES = "notes",
}

export const BUTTER_NOTES_NAMESPACES = [LocaleNamespaceEnum.NOTES];
